export const NOTIFICATIONS_UPDATED = 'NOTIFICATIONS_UPDATED';

export const AUTHENTICATING = 'AUTHENTICATING';
export const AUTH_UPDATE = 'AUTH_UPDATE';
export const USER_UPDATE = 'USER_UPDATE';

export const USERS_UPDATE = 'USERS_UPDATE';
export const USERS_LOADING = 'USERS_LOADING';

export const EXERCISES_UPDATE = 'EXERCISES_UPDATE';
export const PROGRAMS_UPDATE = 'PROGRAMS_UPDATE';

export const LOADING_TRIAL_PERIOD = 'LOADING_TRIAL_PERIOD';
export const TRIAL_PERIOD_UPDATE = 'TRIAL_PERIOD_UPDATE';
export const MISC_UPDATE = 'MISC_UPDATE';

export const LOADING_BANNER = 'LOADING_BANNER';
export const BANNER_UPDATE = 'BANNER_UPDATE';

export const PROCESSING_PROGRAM = 'PROCESSING_PROGRAM';